var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.5H1.5M3.75 9H1.5M3.75 13.5H1.5M13.125 5.25H10.125M11.625 8.25H10.125M6.75 16.5V1.5M16.5 10.5V7.5C16.5 4.67157 16.5 3.25736 15.6213 2.37868C14.7427 1.5 13.3284 1.5 10.5 1.5H9C6.17157 1.5 4.75736 1.5 3.87868 2.37868C3 3.25736 3 4.67157 3 7.5V10.5C3 13.3284 3 14.7427 3.87868 15.6213C4.75736 16.5 6.17157 16.5 9 16.5H10.5C13.3284 16.5 14.7427 16.5 15.6213 15.6213C16.5 14.7427 16.5 13.3284 16.5 10.5Z",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksIcon);
export default __webpack_public_path__ + "static/media/how-it-works-icon.8d55f615a0e70a29ba414ace82d80d17.svg";
export { ForwardRef as ReactComponent };